import { Link } from 'react-router-dom';
import Section from '../components/Section';
import TrustPillars from '../components/TrustPillars';
import HowItWorks from '../components/HowItWorks';
import Personas from '../components/Personas';
import Arrow from '../components/Arrow';
import { Magnet } from '../reactbits';
import { useLanguage } from '../context/LanguageContext';

export default function WhyNapho() {
  const { t } = useLanguage();
  const gets = [t('get.1'), t('get.2'), t('get.3'), t('get.4')];

  return (
    <>
      <Section eyebrow={t('why.eyebrow')} title={t('why.title')} lead={t('vision.body')} />

      <Section alt>
        <div className="grid grid-2">
          <div className="card">
            <h3 className="card__title">{t('problem.title')}</h3>
            <p>{t('problem.body')}</p>
          </div>
          <div className="card">
            <h3 className="card__title">{t('vision.title')}</h3>
            <p>{t('vision.body')}</p>
          </div>
        </div>
      </Section>

      <Section title={t('trust.title')} eyebrow={t('trust.eyebrow')}>
        <TrustPillars />
      </Section>

      <Section alt eyebrow={t('how.eyebrow')} title={t('how.title')} lead={t('how.lead')}>
        <HowItWorks />
      </Section>

      <Section eyebrow={t('who.eyebrow')} title={t('who.title')} lead={t('who.lead')}>
        <Personas />
      </Section>

      <Section alt eyebrow={t('get.eyebrow')} title={t('get.title')}>
        <ul className="get-list">
          {gets.map((g) => (
            <li key={g}>
              <span className="get-list__tick" aria-hidden>✓</span>
              {g}
            </li>
          ))}
        </ul>
        <div className="center mt-4">
          <Magnet padding={110} magnetStrength={4}>
            <Link to="/join" className="btn btn--primary">
              {t('cta.join')} <Arrow className="btn__arrow" />
            </Link>
          </Magnet>
        </div>
      </Section>
    </>
  );
}
